/* ============================================================
   CULT RACING — SIZE GUIDE POPUP  (page-neutral)

   A "Size guide" button sits on each product. Clicking it opens the
   chart for that product's garment.

   Ported from the HAVOC drop page (assets/havoc-size-guide.js), with
   one deliberate simplification: that version INJECTED the buttons
   from JS, because the lot markup lives in snippets/drop-lot.liquid
   which is shared with the frozen Black Sheep page and could not be
   edited. The homepage template is shared with nothing, so its
   buttons are rendered in Liquid where they belong. No injection, no
   layout shift, and no reading the garment back out of the DOM.

   So this file owns open/close only, and is driven entirely by data
   attributes:
     [data-guide="<key>"]        a button; key matches a panel
     [data-guide-label="<text>"] what to call the garment in the title
     [data-guide-panel="<key>"]  one chart inside #sizeGuide

   Any page that renders those gets the feature by loading this pair.

   The charts are server-rendered, so there is no fetch and nothing to
   wait for: the popup opens instantly and works with a dead network.
   ============================================================ */
(function () {
  "use strict";

  var box = document.getElementById("sizeGuide");
  if (!box) return;

  /* 🔴 NO SNAPSHOT OF THE BUTTONS, and no early return on an empty one.
     This used to capture [data-guide] at load and attach a listener to each.
     cr-colors.js CREATES the size guide button for every colour picker lot at
     runtime, after this file has run, so those buttons rendered, looked
     identical and did nothing: 10 of 24 dead on the UNREGISTERED drop page,
     every one of them on a colour lot. Delegation removes the load-order
     dependency for good — a button that appears later still works. */

  var panel   = box.querySelector(".sg__panel");
  var titleEl = box.querySelector(".sg__title");
  var closeEl = box.querySelector(".sg__close");
  var panels  = [].slice.call(box.querySelectorAll("[data-guide-panel]"));
  var lastFocus = null;

  function open(which, label) {
    var found = false;
    panels.forEach(function (p) {
      var match = p.getAttribute("data-guide-panel") === which;
      p.hidden = !match;
      if (match) found = true;
    });
    /* no chart for this garment (an accessory, or a type added later):
       say nothing rather than opening an empty box */
    if (!found) return;

    titleEl.textContent = (label || "Size") + " size guide";
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add("sg-open");
    closeEl.focus();
  }

  function close() {
    if (box.hidden) return;
    box.hidden = true;
    document.documentElement.classList.remove("sg-open");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-guide]");
    if (!b) return;
    /* the button rides inside the product card, which on this page is
       not itself a link, but stopPropagation keeps it safe if the card
       ever becomes one */
    e.preventDefault();
    e.stopPropagation();
    open(b.getAttribute("data-guide"), b.getAttribute("data-guide-label"));
  });

  closeEl.addEventListener("click", close);

  /* click anywhere off the panel closes. Bound on the overlay and
     filtered by containment, so a click that starts inside the panel
     (selecting a number in the table) never closes it. */
  box.addEventListener("click", function (e) {
    if (!panel.contains(e.target)) close();
  });

  document.addEventListener("keydown", function (e) {
    if (!box.hidden && e.key === "Escape") close();
  });
})();
